import { useStyletron } from "baseui";
import React from "react";
import { ExampleFallbackAPIReferenceRelativeLink } from "../markdown-components/RelativeLinks";
import { SplashCalloutLink } from "./SplashPage";

export const APIReferenceCalloutLink = () => {
  const [css] = useStyletron();

  return (
    <SplashCalloutLink>
      <span className={css({ fontWeight: 500 })}>Looking for your API?</span> Check out your API documentation{" "}
      <ExampleFallbackAPIReferenceRelativeLink path="/">here</ExampleFallbackAPIReferenceRelativeLink>.
    </SplashCalloutLink>
  );
};
